/** @type {import('next-i18next').UserConfig} */
const getDomains = () => {
  const env = process.env.NEXT_PUBLIC_ENV || process.env.NODE_ENV;

  if (env === 'production') {
    return [
      { domain: 'stockholmbusinessregion.se', defaultLocale: 'sv' },
      { domain: 'en.stockholmbusinessregion.se', defaultLocale: 'en' },
    ];
  }

  if (env === 'stage' || env === 'staging') {
    return [
      { domain: 'stage.stockholmbusinessregion.se', defaultLocale: 'sv' },
      { domain: 'stage-en.stockholmbusinessregion.se', defaultLocale: 'en' },
    ];
  }

  // local/dev fallback
  return [
    { domain: 'stockholmbusinessregion.se.test', defaultLocale: 'sv' },
    { domain: 'en.stockholmbusinessregion.se.test', defaultLocale: 'en' },
  ];
};

module.exports = {
  i18n: {
    defaultLocale: 'sv',
    locales: ['sv', 'en'],
    localeDetection: false,
    domains: getDomains(),
  },
};
